import { render, staticRenderFns } from "./GoodsShowRuleConfig.vue?vue&type=template&id=807a70ca&scoped=true"
import script from "./GoodsShowRuleConfig.vue?vue&type=script&lang=js"
export * from "./GoodsShowRuleConfig.vue?vue&type=script&lang=js"
import style0 from "./GoodsShowRuleConfig.vue?vue&type=style&index=0&id=807a70ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "807a70ca",
  null
  
)

export default component.exports